import Vue from "vue";
import VueRouter from "vue-router";
//A-Z
import AboutUs from "@/module/Static/page/AboutUs.vue";
import Contact from "@/module/Static/page/Contact.vue";
import Home from "@/module/Home/page/Home.vue";
import Default from "@/module/Home/page/Default.vue";
import History from "@/module/History/page/History.vue";
import Register from "@/module/Register/page/Register.vue";
import RewardAlive from "@/module/Reward/page/RewardAlive.vue";
import Reward from "@/module/List/page/Reward.vue";
import RewardDetail from "@/module/Detail/page/Campaign.vue";
import LineLogin from "@/module/LineLogin/page/LineLogin.vue";
import Login from "@/module/Login/page/Login.vue";
import Profile from "@/module/Profile/page/Profile.vue";
import EditProfile from "@/module/Profile/page/EditProfile.vue";
import SurveyEditProfile from "@/module/Profile/page/SurveyEditProfile.vue";
import PointCollection from "@/module/ScanQRCode/page/PointCollection.vue";
import PointGuideline from "@/module/PointCollection/page/PointGuideline.vue";
import ScanQRCode from "@/module/ScanQRCode/page/ScanQRCode.vue";
import Terms from "@/module/Static/page/Terms.vue";
import Privacy from "@/module/Static/page/Privacy.vue";
import MissionAlive from "@/module/Mission/page/MissionAlive.vue";
import Mission from "@/module/Mission/page/MissionList.vue";
import MissionDetail from "@/module/Mission/page/MissionDetail.vue";
import Luckydraw from '@/module/Luckydraw/page/Luckydraw.vue'
import Announcement from "@/module/Announcement/page/Announcement.vue"
import LeaderBoard from "@/module/LeaderBoard/page/LeaderBoard.vue"
import VerifyBirthday from "@/module/Login/page/VerifyBirthday.vue";
import Survey from '@/module/Register/page/Survey.vue'
Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'default',
        component: Home,
    },
    {
        path: '/default',
        name: 'default1',
        component: Default,
    },
    {
        path: '/about',
        name: 'AboutUs',
        component: AboutUs
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact
    },
    {
        path: '/home',
        name: 'home',
        component: Home
    },
    {
        path: '/rewards',
        name: 'reward',
        component: RewardAlive,
        children: [
            {
                path: '/rewards/:catId?',
                name: 'reward list',
                component: Reward
            }, 
            {
                path: '/reward/:campaignId',
                name: 'reward detail',
                component: RewardDetail
            }
        ]
    },
    {
        path: '/linelogin',
        name: 'Linelogin',
        component: LineLogin
    },
    {
        path: '/qrcode',
        name: 'qrcode',
        component: ScanQRCode
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/register',
        name: 'Register',
        component: Register
    },
    {
        path: '/survey',
        name: 'survey',
        component: Survey
    },
    {
        path: '/verify/birthday',
        name: 'verify',
        component: VerifyBirthday
    },
    {
        path: '/point',
        name: 'PointCollection',
        component: PointCollection
    },
    {
        path: '/point/guide',
        name: 'PointGuideline',
        component: PointGuideline
    },
    {
        path: '/profile',
        name: 'Profile',
        component: Profile
    },
    {
        path: '/profile/edit',
        name: 'EditProfile',
        component: EditProfile
    },
    {
        path: '/surveyeditprofile',
        name: 'SurveyEditProfile',
        component: SurveyEditProfile
    },
    {
        path: '/terms',
        name: 'terms',
        component: Terms
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: Privacy
    },
    {
        path: '/history',
        name: 'history',
        component: History
    },
    {
        path: '/history/:type',
        name: 'historytype',
        component: History
    },
    {
        path: '/mission',
        name: 'mission',
        component: MissionAlive,
        children: [
            {
                path: '/mission',
                name: 'mission list',
                component: Mission
            }
        ]
    },
    {
        path: '/mission/:type',
        name: 'missiontype',
        component: MissionDetail
    },
    {
        path: '/luckydraw',
        name: 'luckydraw',
        component: Luckydraw
    },
    {
        path: '/luckydraw/:campaignId',
        name: 'luckydraw detail',
        component: RewardDetail
    },
    {
        path: '/announce',
        name: 'announce',
        component: Announcement
    },
    {
        path: '/leaderboard',
        name: 'leaderboard',
        component: LeaderBoard
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;
